export class CompanyModel {
    id: string;
    name: string;
    street: string;
    city: string;
    zipCode: string;
    country: string;
    projects: string[];
}
